import { Component, h } from 'preact'
import axios from 'axios'
import Panel from '../panel'
import IntegrationHeader from './IntegrationHeader'
import ZapierLogo from './assets/zapierLogo.js'
import InputGroup from '../ui-components/InputGroup'
import ButtonControl from '../button-control'
import AlertComponent from '../ui-components/AlertComponent'

interface Props {
  csrfToken: string
}

interface State {
  apiKey: string,
  messageType?: string|null,
  message?: string,
  isInstalled: boolean,
  isLoading?: boolean
}

class ZapierIntegration extends Component<Props, State> {
  endpoint: string
  headerDescription: string
  constructor (props: Props) {
    super(props)
    this.state = {
      apiKey: '',
      messageType: null,
      message: '',
      isInstalled: false
    }
    this.endpoint = '/integration/zapier/settings'
    this.headerDescription = 'Connect with thousands of other apps like Slack and Jira to build workflows, automate repetitive tasks and save time.'
    this.onGenerateApiKey = this.onGenerateApiKey.bind(this)
  }

  async componentDidMount () {
    this.setState({ messageType: null })
    try {
      const res = await axios.get(this.endpoint)
      if ('key' in res.data) {
        this.setState({ apiKey: res.data.key, isInstalled: true })
      }
    } catch (e) {
      this.setState({ isInstalled: false, messageType: 'error', message: 'Unable to retrieve Zapier API key.' })
    }
  }

  async onGenerateApiKey () {
    const successMessage = 'Zapier key generated successfully!'
    this.setState({ messageType: null })
    try {
      const res = await axios.post(this.endpoint, { csrfToken: this.props.csrfToken })
      if (res.data) {
        this.setState({ apiKey: res.data.key, isInstalled: true, messageType: 'success', message: successMessage })
      }
    } catch (e) {
      this.setState({ isInstalled: false, messageType: 'error', message: 'Could not generate key, please try again later.' })
    }
  }

  render (props: Props, state: State) {
    const isVisibleFor = state.messageType === 'success' ? 5000 : false
    return (
      <div class='integrations-zapier'>
        <Panel title={<IntegrationHeader isInstalled={state.isInstalled} name='Zapier' description={this.headerDescription}><ZapierLogo /></IntegrationHeader>}>
          {
            state.messageType ? <AlertComponent messageType={state.messageType} message={state.message} sticky renderHTML isVisibleFor={isVisibleFor} /> : null
          }
          <InputGroup type='text' qaClasses='qa-zapier-api-key-input' readOnly='readonly' value={state.apiKey} placeholder='Click the button to generate API key' />
          { state.apiKey
            ? null : <ButtonControl variant='primary' title='Generate API Key' class={'qa-generate-api-key'} onClick={this.onGenerateApiKey} /> }
        </Panel>
      </div>
    )
  }
}

export default ZapierIntegration
